import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNewLayout } from "store/selectors/hooks";
import { designSlice } from "store/slices/design";

export const usePreviewDesignToggle = () => {
    const dispatch = useDispatch();
    const isUseNewDesignChecked = useNewLayout();
    const { setPreviewDesign } = designSlice.actions;

    const handlePreviewChange = useCallback(
        async (enabled: boolean) => {
            dispatch(setPreviewDesign(enabled ? "new" : "legacy"));
        },
        [dispatch, setPreviewDesign],
    );

    return {
        isUseNewDesignChecked,
        handlePreviewChange,
    };
};
